import { Outlet, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import usePersistLogin from "../hooks/usePersistLogin";
import Loader from "./Loader";
import styles from "./persistLogin.module.css";

const PersistLogin = () => {
  const { token, user, refreshToken } = usePersistLogin();
  const location = useLocation();

  return (
    <>
      {refreshToken ? (
        <>
          {user && token ? (
            <Outlet />
          ) : (
            <div className={styles.loaderContainer}>
              <Loader />
            </div>
          )}
        </>
      ) : (
        <Navigate to="/login" state={{ from: location }} replace />
      )}
    </>
  );
};

export default PersistLogin;
